import {
    pink, amber, deepPurple
  } from '@material-ui/core/colors';

  export const TrainingDetails = [
    {
      text: 'אישי',
      id: 1,
      color: deepPurple[500],
    }, {
      text: 'VIP',
      id: 2,
      color: amber,
    }, {
      text: 'מתנדב',
      id: 3,
      color: amber[200],
    }, {
      text: 'קבוצתי',
      id: 4,
      color: deepPurple[200],
    }, {
      text: 'מוסד',
      id: 5,
      color: deepPurple[300],
    }, {
        text: 'Online',
        id: 6,
        color: amber[600],
    },
  ];


  export const Trainees = [
    {
      text: 'רותם גביש',
      id: 1,
      color: pink[1],
    }, {
      text: 'גל גולדשטיין',
      id: 2,
      color: pink[2],
    }, {
      text: 'אורי מרום',
      id: 3,
      color: pink[300],
    }, {
      text: 'עומר צוויג',
      id: 4,
      color: pink[400],
    }, {
      text: 'דור שירן',
      id: 5,
      color: pink[500],
    }, {
      text: 'רותם מאירצוק',
      id: 6,
      color: pink[600],
      }, {
      text:  'הגר דהן',
      id: 7,
      color: pink[700],
    }
  ];

  export const triningType = [
    {
      text: 'שחייה',
      id: 1,
    }, {
      text: 'ריצה',
      id: 2,
    }, {
      text: 'TRX',
      id: 3,
    }, {
      text: 'ריקוד',
      id: 4,
    }, {
      text: 'אחר',
      id: 5,
    },
  ];
